var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { useStyles } from "../assets/style";
import "../assets/style.css";
import { ButtonAFY, CobranzaAFY, sizes, variants, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { themeCore } from "../../../assets/themes/theme";
import { Title } from "../../../components/layout/style";
var View = function (props) {
    var classes = useStyles();
    var _a = React.useState(props.products), products = _a[0], setProducts = _a[1];
    useEffect(function () {
        if (props.products && props.products.length > 0) {
            setProducts(props.products);
        }
    }, [props.products]);
    var onClickNext = function (e) {
        props.onClickNext && props.onClickNext(e);
    };
    var onClickBack = function (e) {
        props.onClickBack && props.onClickBack(e);
    };
    return (_jsxs(React.Fragment, { children: [_jsxs("div", __assign({ style: { display: "flex", justifyContent: "space-between", alignItems: "center" } }, { children: [_jsx(Title, { children: props.title }), _jsxs("div", __assign({ style: { display: "flex", justifyContent: "space-between", alignItems: "center" } }, { children: [_jsx("div", __assign({ style: { marginRight: "10px" } }, { children: _jsx(ButtonAFY, { variant: variants.contained, size: sizes.large, label: "Refrescar", color: "#fff", backgroundColor: themeCore.colors.success, onClick: function (e) {
                                        e.stopPropagation();
                                        props.onClickRefresh();
                                    } }) })), _jsx(ButtonAFY, { variant: variants.contained, size: sizes.large, label: "Generar Cobro", backgroundColor: '#1D34FE', onClick: function (e) {
                                    e.stopPropagation();
                                    props.onClickGenerate();
                                } })] }))] })), _jsx("div", __assign({ className: "containerPanel", style: { marginTop: "15px" } }, { children: _jsx(CobranzaAFY, { title: "   Cobranza  ", data: props.data, columns: props.columns, onClickGenerate: props.onClickGenerate, onClickDownload: props.onClickDownload, backgroundColorBack: props.backgroundColorBack, backgroundColorNext: props.backgroundColorNext, onClickNext: onClickNext, onClickBack: onClickBack, count: props.count, pagePagination: props.pagePagination, rowsPerPages: props.rowsPerPages, onChangePage: props.onChangePage, onChangeRowsPerPage: props.onChangeRowsPerPage, next: {
                        nextLabel: "",
                        previousLabel: "",
                        nextDisabled: false,
                    } }) }))] }));
};
export default View;
